import {
  Component,
  OnInit,
  OnDestroy,
  ComponentRef,
  ViewChild,
  ViewContainerRef,
  AfterViewInit,
  ChangeDetectorRef,
  AfterContentChecked
} from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { ICheckoutMenu } from '../models/imenu.model';
import { ShoppingCartService } from '../services/shopping-cart.service';
import { ShoppingCart } from '../models/shopping-cart.model';
import { CommonService } from '../services/common.service';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { CheckOutService } from '../services/checkout.service';
import { CheckoutStatusModel } from '../models/check-out.model';
import { BreadcrumbComponent } from '../breadcrumb/breadcrumb.component';
import { Subject } from 'rxjs';
import { WatchListItemNew } from '../models/watch-list.model';

// ngrx
import { Store } from '@ngrx/store';
import { getWatchListStateLoaded, getWatchListStateProducts } from '../reducers/watchlist.reducer';
import { LoadWatchList } from '../actions/watchlist.actions';
import { AppState } from '../reducers';
import { getShoppingCarts, getShoppingCartLoaded, getSelectedShoppingCart, getIsCreatingShoppingCart } from '../reducers/shoppingcart.reducer';
import { CreateShoppingCart, SelectShoppingCart, LoadShoppingCart } from '../actions/shoppingcart.actions';
import { CurrentUserModel } from '../models/account-ledger.model';
import { AuthService } from '../services/auth.service';
import { combineLatest } from 'rxjs';
import { filter, take, takeUntil } from 'rxjs/operators';
import { ExternalScriptService } from '../services/external-script.service';


declare var jquery: any;
declare var $: any;

@Component({
  selector: 'app-my-carts',
  templateUrl: './my-carts.component.html',
  styleUrls: ['./my-carts.component.css']
})

export class MyCartsComponent implements OnInit, OnDestroy {

  title = 'My Carts';
  created = false;

  // the component can be any instance of the child component in the second menu
  component: ComponentRef<any>;

  // tslint:disable-next-line:no-trailing-whitespace
  @ViewChild('entry', { read: ViewContainerRef }) entry: ViewContainerRef;
  @ViewChild(BreadcrumbComponent, {static: true}) breadcrumbRef: BreadcrumbComponent;



  // css variable
  setFullWindow = false;
  subWidth: string;
  shoppingCarts: ShoppingCart[] = [];
  shoppingCartsFilter: ShoppingCart[] = [];
  randomNameArray: string;
  cartId: string;
  selectedCartId: number;
  searchText: string;
  tenantDetailsRequired: string;
  searchField = '';
  closeResult: string;
  urlSegments: string[];
  lastChild: string;
  sortOrder = true;
  watchListItems: WatchListItemNew[];
  checkoutInitiated = false;
  defaultFirstStep = '';
  currentCheckoutStep = '';
  checkoutStatus: CheckoutStatusModel;
  checkoutMenuFilter: ICheckoutMenu[];
  viewProduct = false;
  isCheckOut = false;
  // checkout process menus
  checkoutMenu: ICheckoutMenu[] = [
    {
      menuName: 'Delivery Location',
      stepName: 'ADDRESS',
      id: 'addressStep',
      selected: false
    },
    {
      menuName: 'End User Information',
      stepName: 'ENDUSER',
      id: 'endUserStep',
      selected: false
    },
    {
      menuName: 'Autopilot Enrolment',
      stepName: 'TENANT',
      id: 'tenantStep',
      selected: false
    },
    {
      menuName: 'Freight & Shipping Method',
      stepName: 'FREIGHT',
      id: 'freightStep',
      selected: false
    },
    {
      menuName: 'Donation',
      stepName: 'DONATION',
      id: 'donationStep',
      selected: false
    },
    {
      menuName: 'Payment',
      stepName: 'PAYMENT',
      id: 'paymentStep',
      selected: false
    },
    {
      menuName: 'Summary & Order',
      stepName: 'SUMMARY',
      id: 'summaryStep',
      selected: false
    }
  ];
  loadContent = false;
  loadShoppingCart = false;
  ngUnsubscribe: Subject<void> = new Subject<void>();
  showXscroll = false;

  watchListView = false;
  currentUserModel: CurrentUserModel;

  constructor(
    private router: Router,
    private shoppingCartService: ShoppingCartService,
    private commonService: CommonService,
    private modalService: NgbModal,
    private checkoutService: CheckOutService,
    private externalScriptService: ExternalScriptService,
    private activeRouter: ActivatedRoute,
    private authService: AuthService,
    private cdr: ChangeDetectorRef,
    private store: Store<AppState>
  ) {
    this.commonService.emitUpdateSideBarActiveItem('carts');
  }

  ngOnInit() {
    this.loadContent = false;
    this.checkoutInitiated = false;
    this.urlSegments = [];
    this.lastChild = '';
    this.externalScriptService
      .loadScript('https://api.payway.com.au/rest/v1/payway.js')
      .then(() => {
        this.externalScriptService.runMyScript();
      })
      .catch((error) => console.error(error));

    this.authService.getLoginInfo().subscribe((res: CurrentUserModel) => {
      this.currentUserModel = res;
    });

    this.checkoutService.editShowXscroll.subscribe((res: boolean) => {
      this.showXscroll = res;
    },
      (error: any) => {
        console.error(error);
      });

    this.watchListView = this.router.url === '/myCarts/watchlist';

    this.router.events.pipe(filter(event => event instanceof NavigationEnd),takeUntil(this.ngUnsubscribe)).subscribe(res => {
      this.breadcrumbRef.ngAfterViewInit();
      this.urlSegments = this.router.url.split('/');
      this.lastChild = this.urlSegments[this.urlSegments.length - 1];
      if (this.lastChild === 'ship-address') {
        this.currentCheckoutStep = 'ADDRESS';
        this.checkoutMenu.filter(i => i.id === 'addressStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'select-location') {
        this.currentCheckoutStep = 'ADDRESS';
        this.checkoutMenu.filter(i => i.id === 'addressStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'freight-ship') {
        this.currentCheckoutStep = 'FREIGHT';
        this.checkoutMenu.filter(i => i.id === 'freightStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'payment-method') {
        this.currentCheckoutStep = 'PAYMENT';
        this.checkoutMenu.filter(i => i.id === 'paymentStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'donation') {
        this.currentCheckoutStep = 'DONATION';
        this.checkoutMenu.filter(i => i.id === 'donationStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'end-user' || this.lastChild === 'selectenduser') {
        this.currentCheckoutStep = 'ENDUSER';
        this.checkoutMenu.filter(i => i.id === 'endUserStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'summary-order') {
        this.currentCheckoutStep = 'SUMMARY';
        this.checkoutMenu.filter(i => i.id === 'summaryStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'tenant') {
        this.currentCheckoutStep = 'TENANT';
        this.checkoutMenu.filter(i => i.id === 'tenantStep')[0].selected = true;
        this.isCheckOut = true;
      } else if (this.lastChild === 'order-confirmation') {
        this.isCheckOut = true;
      } else if (this.lastChild === 'myCarts') {
        this.isCheckOut = false;
      }

      if (!this.isCheckOut) {
        this.removeCheckoutStatus();
        this.currentCheckoutStep = '';
      }

      if (this.router.url === '/myCarts') {
        $('#levelOne').animate({ scrollLeft: -($('#levelOne').width()) }, 400);
      }

      if (this.router.url === '/myCarts/watchlist') { this.watchListView = true; } else { this.watchListView = false; }

      if (this.router.url.includes('product')) {
        this.viewProduct = true;
      }
    });

    this.checkoutService.currentIsShowCartSummary.pipe(takeUntil(this.ngUnsubscribe)).subscribe(() => this.isCheckOut = false);
    // this.shoppingCartService.cachedShoppingCarts$.takeUntil(this.ngUnsubscribe).subscribe((values: ShoppingCart[]) => {

    //   this.shoppingCarts = values;
    //   this.loadContent = true;
    //   this.sortCartList();
    //   this.shoppingCartsFilter = this.shoppingCarts;
    //   this.shoppingCartsFilter.map(item => item.encodedCartName = encodeURIComponent(item.cartName));
    //   this.shoppingCartService.setSelected(this.shoppingCartsFilter, this.commonService.readCookie('CartId'));
    //   if (values && values.length !== 0) {
    //     if (this.commonService.readCookie('CartId')) {
    //       this.shoppingCartService.monitorCartId(toNumber(this.commonService.readCookie('CartId')));
    //     } else {
    //       this.commonService.createCookie('CartId', values[0].cartId.toString(), 7);
    //       this.shoppingCartService.monitorCartId(toNumber(this.commonService.readCookie('CartId')));
    //     }
    //   } else {
    //     this.shoppingCartService.getShoppingCart().subscribe((value: ShoppingCart[]) => {
    //       if (!value.length) {
    //         this.addNewCart();
    //       }
    //     });
    //   }

    // },
    //   (error: any) => {
    //     console.error(error);
    //   });
    this.store.dispatch(new LoadShoppingCart());

    this.store.select(getWatchListStateLoaded).pipe(take(1))
      .subscribe(hasLoaded => {
        if (!hasLoaded) {
          this.store.dispatch(new LoadWatchList());
        }
        this.store.select(getWatchListStateProducts).subscribe(products => {
          this.watchListItems = products;
          this.loadContent = true;
        }
        );

      });

    this.store.select(getShoppingCartLoaded).subscribe((loaded) => {
      this.loadShoppingCart = loaded;
      if (loaded) {
        this.store.select(getShoppingCarts).subscribe((carts) => {
          this.shoppingCarts = carts;
          this.shoppingCartsFilter = this.shoppingCarts;
          this.shoppingCartsFilter.map(item => item.encodedCartName = encodeURIComponent(item.cartName));
          if (carts.length) {
            this.selectedCartId = carts.find(c => c.isSelected).cartId;
          }
        });

        this.store.select(getSelectedShoppingCart).subscribe(cart => {
          if (cart && this.router.url === '/myCarts') {
            this.router.navigate([`cart/${cart.cartId}/${cart.cartName}`], { relativeTo: this.activeRouter });
          }
        });

        this.store.select(getIsCreatingShoppingCart).subscribe(isCreating => {
          this.loadContent = !isCreating;
        });
      }
    });

    combineLatest([this.checkoutService.skipEndUserStep$, this.checkoutService.changeEmitted$]).pipe(takeUntil(this.ngUnsubscribe))
    .subscribe(([skip, res]) => {
      // an end user has clicked the check out button and ready to check out
      this.checkoutInitiated = res.hasChosenCheckout;
      this.defaultFirstStep = res.firstStep;
      this.currentCheckoutStep = res.currentStep;
      this.checkoutMenuFilter = this.checkoutMenu;
      this.tenantDetailsRequired = res.tenantDetailsRequired;

      this.authService.getLoginInfo().pipe(takeUntil(this.ngUnsubscribe)).subscribe((model: CurrentUserModel) => {
        this.currentUserModel = model;
        // NZ site is not using donation page for now
        // if (!this.currentUserModel.isAU) {
          this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'donationStep');
        // }
      });

      if (res.collectOrder) {
        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'freightStep');
      }
      if (this.tenantDetailsRequired === 'NO' || !this.tenantDetailsRequired) {
        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'tenantStep');
      }

      if (this.defaultFirstStep === 'TENANT') {
        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'addressStep' && item.id !== 'endUserStep' && item.id !== 'freightStep');
      } else if (this.defaultFirstStep === 'ENDUSER') {
        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'addressStep' && item.id !== 'freightStep');
      } else if (this.defaultFirstStep === 'PAYMENT') {
        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'addressStep' && item.id !== 'endUserStep' && item.id !== 'freightStep');
      } else if (this.defaultFirstStep === 'NOENDUSER' || skip) {
        this.checkoutMenuFilter = this.checkoutMenuFilter.filter(item => item.id !== 'endUserStep');
      }
    });

    // this.watchListService.currentWatch.subscribe(res => {
    //   this.watchListService.getWatchList().takeUntil(this.ngUnsubscribe).subscribe(ps => {
    //     this.watchListItems = ps;
    //   },
    //     (error: any) => {
    //       console.error(error);
    //       this.loadContent = true;
    //     });
    // },
    //   (error: any) => {
    //     console.error(error);
    //     this.loadContent = true;
    //   });

    // if (this.shoppingCartsFilter && this.shoppingCartsFilter[0] && this.shoppingCartsFilter[0].cartId) {
    //   this.sortCartList();
    // if (!this.router.url.includes('/myCarts/cart/')) {  // check if other routes redirect from other components
    //   this.router.navigate([`cart/${this.shoppingCartsFilter[0].cartId}/${this.shoppingCartsFilter[0].encodedCartName}`], { relativeTo: this.activeRouter });
    // }
    // }
  }

  addNewCart(): void {
    this.loadContent = false;
    this.randomNameArray = this.shoppingCartService.RandomCartName(this.shoppingCarts);
    this.shoppingCartService.createShoppingCart(this.randomNameArray).subscribe((res: number) => {
      this.shoppingCartService.monitorCartId(res);
      this.shoppingCartService.monitorCartIdChange(res);
      this.commonService.savecookies('CartId', res.toString(), 7);
      this.commonService.showSuccess('.add-icon', 'Create Shopping Cart Successfully', 'right');
      this.shoppingCartService.getShoppingCart().subscribe(sc => {
        this.shoppingCarts = sc;
        this.shoppingCartsFilter = this.shoppingCarts;
        this.shoppingCartService.setSelected(this.shoppingCarts, this.commonService.readCookie('CartId'));
        this.loadContent = true;
      },
        (error: any) => {
          console.error(error);
          this.loadContent = true;
        });

    },
      (error: any) => {
        this.commonService.showError('.add-icon', error.responseMessage, 'right');
        this.loadContent = true;
      });
  }

  addNewCartWithNewName(cartName: string): void {
    if (cartName === '') {
      this.store.dispatch(new CreateShoppingCart());
    } else {
      this.store.dispatch(new CreateShoppingCart(cartName));
    }
    // this.loadContent = false;
    // this.randomNameArray = this.shoppingCartService.RandomCartName(this.shoppingCarts);
    // this.shoppingCartService.createShoppingCart(this.randomNameArray).subscribe((res: number) => {
    //   this.shoppingCartService.monitorCartId(res);
    //   this.shoppingCartService.monitorCartIdChange(res);
    //   this.commonService.savecookies('CartId', res.toString(), 7);
    //   if (cartName !== '') {
    //     this.shoppingCartService.updateCartName(cartName, res)
    //       .subscribe(success => {
    //         if (success.status) {
    //           this.shoppingCartService.monitorCartNameChange(cartName);
    //           this.shoppingCartService.getShoppingCart()
    //             .subscribe(sc => {
    //               this.shoppingCarts = sc;
    //               this.shoppingCartsFilter = this.shoppingCarts;
    //               this.shoppingCartService.setSelected(this.shoppingCartsFilter, this.commonService.readCookie('CartId'));
    //               this.sortCartList();
    //               this.shoppingCartService.setCacheShoppingCart(this.shoppingCartsFilter);
    //               this.loadContent = true;
    //               this.router.navigate([`cart/${res.toString()}/${cartName}`], { relativeTo: this.activeRouter });
    //             },
    //               (error: any) => {
    //                 this.loadContent = true;
    //                 console.error(error);
    //               });
    //         }
    //       },
    //         (error: any) => {
    //           this.loadContent = true;
    //           console.error(error);
    //         });
    //   }
    // });
  }

  accessWatchList(): void {
    this.router.navigate(['watchlist'], { relativeTo: this.activeRouter });
  }

  filterShoppingCarts(): void {
    this.shoppingCartsFilter = this.shoppingCarts.filter(x => x.cartName.toLowerCase().includes(this.searchText.toLowerCase()));
  }

  setActiveCart(shoppingcart: ShoppingCart): void {

    if (shoppingcart.cartId !== this.selectedCartId) {
      this.store.dispatch(new SelectShoppingCart(shoppingcart));
    }

  }
  // setActiveCart(cartId: string) {
  //   this.shoppingCartService.SetActiveCart(cartId).subscribe(res => {
  //     this.commonService.savecookies('CartId', cartId.toString(), 7);
  //     this.shoppingCartService.monitorCartId(toNumber(cartId));
  //   });
  // }

  redirectTo(stepName: string) {

    const segments: string[] = ['ship-address', 'end-user', 'tenant', 'freight-ship', 'payment-method', 'summary-order', 'donation'];

    let newChildSegment = '';

    switch (stepName) {
      case 'ADDRESS': {
        newChildSegment = 'ship-address';
        break;
      }
      case 'ENDUSER': {
        newChildSegment = 'end-user';
        break;
      }
      case 'TENANT': {
        newChildSegment = 'tenant';
        break;
      }
      case 'FREIGHT': {
        newChildSegment = 'freight-ship';
        break;
      }
      case 'DONATION': {
        newChildSegment = 'donation';
        break;
      }
      case 'PAYMENT': {
        newChildSegment = 'payment-method';
        break;
      }
      case 'SUMMARY': {
        newChildSegment = 'summary-order';
        break;
      }

    }

    const urlSegments = this.router.url.split('/');
    const lastChild = urlSegments[urlSegments.length - 1];
    // const newUrl = this.router.url.toString().replace(lastChild, newChildSegment);
    // this.router.navigate([newUrl]);
    if (segments.includes(lastChild)) {
      const newUrl = this.router.url.toString().replace(lastChild, newChildSegment);
      this.router.navigateByUrl(newUrl);
    } else {
      const newUrl = `${this.router.url}/${newChildSegment}`;
      this.router.navigateByUrl(newUrl);
    }

  }
  navigateTo(url: string) {
    this.router.navigate([url]);
  }
  open(content: any, event) {
    event.preventDefault();
    event.stopPropagation();
    this.openModal(content);
  }

  openModal(content: any) {
    this.modalService.open(content, { centered: true }).result.then(
      result => {
        this.closeResult = `Closed with: ${result}`;
      },
      reason => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  sortCartList(): void {
    this.shoppingCarts = this.commonService.orderBy(this.shoppingCarts, [
      (item: ShoppingCart) => item.isSelected,
      (item: ShoppingCart) => item.status
    ], ['desc', 'desc']);
    
    this.shoppingCartsFilter = this.shoppingCarts;
  }

  ngOnDestroy(): void {
    this.commonService.emitUpdateSideBarActiveItem('');
    this.checkoutInitiated = false;
    this.removeCheckoutStatus();
    this.ngUnsubscribe.next();
    this.ngUnsubscribe.complete();
  }

  closeCheckoutPanel() {
    var myCartUrl =  this.checkoutInitiated ? this.router.url.split('/',5).join('/') : 'myCarts';
    this.removeCheckoutStatus();
    this.router.navigateByUrl(myCartUrl);
  }

  onLoading(currentLoadingStatus: boolean) {
    this.loadContent = !currentLoadingStatus;
  }

  removeCheckoutStatus() {
    this.checkoutStatus = {
      currentStep: '',
      firstStep: '',
      hasChosenCheckout: false,
      collectOrder: false,
      tenantDetailsRequired: ''
    };
    this.checkoutService.emitChange(this.checkoutStatus);
  }

  onClicked(message: string): void {
    if (message === 'clicked') {
      this.removeCheckoutStatus();
    }
  }


}
